import {Product} from '../../modules/warehouse/modules/product/interfaces/product';

/**
 * Berechnet den Bruttopreis eines Produktes
 * @param product
 * TODO: Brutto Wert sollte aus dem Backend zurückgegeben werden
 */
export function getBrutto (product: Product) {
  const multiplier = product.Ust / 100 + 1;
  let brutto = product.Price * multiplier;
  brutto = Math.round(brutto * 100) / 100;
  return brutto;
}
